	<template>
  <div class="partners">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item, index) in data.partner" :key="index" >
        <div
          :id="'partner-toast'+index"
          class="slide-item-container d-flex justify-content-center align-items-center"
        >
          <img :src="item.img.url" alt />
        </div>
        <!-- <b-toast :id="`partner-toast${index}`" :title="item.title" static>
          <p class="toast-description">{{item.text}}</p>
        </b-toast> -->
        <b-popover :target="'partner-toast'+index" triggers="hover" placement="bottom">
          <template v-slot:title>{{item.title}}</template>
          <p class="toast-description">{{item.text}}</p>
        </b-popover>
      </swiper-slide>
      <div
        class="control-container d-flex justify-content-start align-items-center"
        slot="pagination"
      >
        <div class="swiper-pagination swiper-pagination-bullets"></div>
      </div>
    </swiper>
  </div>
</template>
	
	<script>
const axios = require("axios");
export default {
  data() {
    return {
      data: {},
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 18
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      }
    };
  },
  beforeCreate() {
    axios
      .get(`${this.$root.routLink}/?ajax&act=partners`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
        if (this.data.visible !== 1) {
          this.$emit("hideup");
        }
      });
  }
};
</script>
	
	<style lang="scss" scoped>
.partners {

  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    margin-right: -15px;
  }
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    .swiper-slide {
      width: 80%;
      .slide-item-container {
        width: 255px;
      }
    }
  }
  .swiper-container {
    .swiper-pagination {
      left: 50%;
      transform: translateX(-50%);
    }
    .swiper-wrapper {
      margin-bottom: 20px;
    }
    .swiper-slide {
      .slide-item-container {
        cursor: pointer;
        height: 110px;
        border: 2px solid #f6f6f6;
        background-color: $defaultColor;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .control-container-buttons {
    width: 94px;
    height: 40px;
    background: rgba(208, 134, 134, 0.4);
    border: 1px solid #d08686;
    box-sizing: border-box;
    border-radius: 70px;
    .gallery-swiper-button-next,
    .gallery-swiper-button-prev {
      height: 100%;
      width: 50%;
    }
    .swiper-button-disabled {
      svg {
        path {
          fill: #ffffff;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.b-toast {
  width: 280px;
  transform: translate(-60px, -60px);
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    transform: translate(10px, -60px);
  }
}
.toast-header {
  color: $mainFontColor;
  font-size: 14px;
  font-weight: 700;
  border-bottom: none;
}
.toast-body {
  background-color: #fff;
}
.swiper-slide-active .b-toast {
  transform: translate(0px, -60px);
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    transform: translate(10px, -60px);
  }
}
.swiper-slide-active + div + div + div + div .b-toast {
  transform: translate(-120px, -60px);
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    transform: translate(10px, -60px);
  }
}
</style>
